/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 3/13/2019.
 */

import {
    CLEAR_STATE,
    SET_ASSET_CONFIGURABLE_ATTRIBUTE,
    REQUEST_SUBMIT_ASSET,
    RECEIVE_SUBMIT_ASSET,
    REQUEST_FLEETS_HIERARCHY,
    RECEIVE_FLEETS_HIERARCHY,
    RECEIVE_ERROR,
    REQUEST_ASSET,
    RECEIVE_ASSET,
    REQUEST_DELETE_ASSET,
    REQUEST_ATTRIBUTES,
    RECEIVE_ATTRIBUTES,
    REQUEST_VARIANTS,
    RECEIVE_VARIANTS,
    SET_ASSET_ATTRIBUTE,
    GENERAL_RECEIVE,
    GENERAL_REQUEST,
    REQUEST_AVAILABLE_CONFIGURATION_SYMPTOMS,
    RECEIVE_AVAILABLE_CONFIGURATION_SYMPTOMS,
    SET_CONFIGURATION_SYMPTOM,
    REQUEST_ASSETS,
    RECEIVE_ASSETS
} from "./AssetActions";

const initialState = {
    asset: {
        id: null,
        name: '',
        fleetId: null,
        attributes: [],
        variants: new Map(),
        configurationSymptoms: [],
        predictiveIndicators: [],
    },
    loading: false,
    fleetsHierarchy: [],
    assets: [],
    availableConfigurationSymptoms: [],
    attributes: [],
    variants: new Map(),
}

export const assetReducer = (state = initialState, action) => {
    switch (action.type) {
        case GENERAL_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case REQUEST_SUBMIT_ASSET:
            return {
                ...state,
                loading: true,
            }
        case RECEIVE_SUBMIT_ASSET:
            return {
                ...state,
                loading: false,
                asset: action.asset,
            }
        case CLEAR_STATE:
            return {
                ...state,
                asset: initialState.asset,
                availableConfigurationSymptoms: initialState.availableConfigurationSymptoms,
                variants: initialState.variants,
                attributes: initialState.attributes,
                loading: false,
            }
        case GENERAL_RECEIVE:
            return {
                ...state,
                loading: false,
            }
        case SET_ASSET_ATTRIBUTE:
            var newState = {
                ...state,
            }

            const newAsset = {}
            newAsset[action.key] = action.value
            newState.asset = Object.assign({}, newState.asset, newAsset)
            return newState
        case SET_ASSET_CONFIGURABLE_ATTRIBUTE:
            var newState = {
                ...state,
            }
            newState.asset = Object.assign({}, newState.asset, newAsset)
            if(!Array.isArray(newState.asset.attributes)) {
                newState.asset.attributes = [];
            }

            let attrFound = false;
            newState.asset.attributes.forEach(item => { // override existing attribute
                if (item.code === action.code) {
                    item[action.property] = action.value;
                    attrFound = true;
                }
            });

            if (!attrFound) {
                const dataType = newState.attributes.map(item => {
                    if (item.code === action.code) {
                        return (item.type)
                    } else {
                        return ('')
                    }
                }).join('');
                const newAttribute = {code: action.code, dataType: dataType};

                if (dataType === 'string') {
                    newAttribute['valueString'] = action.value;
                } else if (dataType === 'date') {
                    newAttribute['valueDate'] = action.value;
                } else if (dataType === 'integer') {
                    newAttribute['valueInteger'] = action.value;
                } else if (dataType === 'float') {
                    newAttribute['valueFloat'] = action.value;
                }
                newState.asset.attributes.push(newAttribute);
            }
            return newState
        case REQUEST_FLEETS_HIERARCHY:
            return {
                ...state,
                fleetsHierarchy: initialState.fleetsHierarchy,
                loading: true,
            }
        case RECEIVE_FLEETS_HIERARCHY:
            return {
                ...state,
                loading: false,
                fleetsHierarchy: action.fleets,
            }
        case REQUEST_ASSETS:
            return {
                ...state,
                assets: initialState.assets,
                loading: true,
            }
        case RECEIVE_ASSETS:
            return {
                ...state,
                loading: false,
                assets: action.assets,
            }
        case RECEIVE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error.errorKey,
            }
        case REQUEST_ASSET:
            return {
                ...state,
                asset: initialState.asset,
                loading: true,
            }
        case RECEIVE_ASSET:
            return {
                ...state,
                loading: false,
                asset: action.asset,
                error: null,
            }
        case REQUEST_ATTRIBUTES:
            return {
                ...state,
                attributes: initialState.attributes,
                loading: true,
            }
        case RECEIVE_ATTRIBUTES:
            return {
                ...state,
                loading: false,
                attributes: action.attributes,
            }
        case REQUEST_VARIANTS:
            return {
                ...state,
                variants: initialState.variants,
                loading: true,
            }
        case RECEIVE_VARIANTS:
            if (action.variants == null) {
                return {
                    ...state,
                    loading: false,
                    variants: action.variants,
                }
            }
            const newVariants = new Map();
            action.variants.forEach(v => {
                let varSet = newVariants.get(v.variantType);
                if (varSet == null) {
                    varSet = [];
                }
                varSet.push(v);
                newVariants.set(v.variantType, varSet);
            })
            return {
                ...state,
                loading: false,
                variants: newVariants,
            }
        case REQUEST_DELETE_ASSET:
            return {
                ...state,
                loading: true,
            }
        case SET_CONFIGURATION_SYMPTOM:
            const newConfigurationSymptoms = state.availableConfigurationSymptoms.map(o => {
                if (o.id === action.id) {
                    return Object.assign({}, o, {newState: action.value})
                } else {
                    return o;
                }
            });
            return {
                ...state,
                availableConfigurationSymptoms: newConfigurationSymptoms,
            }
        case REQUEST_AVAILABLE_CONFIGURATION_SYMPTOMS:
            return {
                ...state,
                availableConfigurationSymptoms: initialState.availableConfigurationSymptoms,
                loading: true,
            }
        case RECEIVE_AVAILABLE_CONFIGURATION_SYMPTOMS:
            return {
                ...state,
                loading: false,
                availableConfigurationSymptoms: action.availableConfigurationSymptoms,
            }
        default:
            return state
    }
}